import PartnerM365Integration from './PartnerM365Integration';

export default PartnerM365Integration;
